{
  "footer": {
    "alreadyPartner": "Già partner?",
    "back": "Indietro",
    "letsgo": "Andiamo!",
    "login": "Accedi",
    "next": "Avanti",
    "readMore": "Scopri di più",
    "signUp": "Registrati"
  },
  "formErrors": {
    "address": "Non è stato possibile trovare questo indirizzo. Per favore, inseriscine uno esistente",
    "businessName": "Questo nome non è disponibile. Per favore, scegline un altro",
    "email": "Questo indirizzo email non è disponibile",
    "verificationCode": "Codice non valido"
  },
  "global": {
    "title": "Unisciti a Treatwell"
  },
  "input": {
    "businessName": {
      "invalid": "Il nome dell'azienda è troppo lungo",
      "label": "Nome dell'attività",
      "required": "Campo obbligatorio"
    },
    "businessSegment": {
      "aesthetics": "Centro Estetico",
      "barber": "Barbiere",
      "beautician": "Estetista",
      "hair-removal": "Epilazione",
      "hairdresser": "Parrucchiere",
      "massage": "Massaggi",
      "nails": "Unghie",
      "primary": "Primario",
      "required": "Seleziona almeno un'opzione",
      "spa": "Spa"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "Dichiaro di avere una stanza separata e dedicata alla mia attività.",
      "home": "Home based <0>- i clienti vengono a casa tua</0>",
      "mobile": "A domicilio <0>- ti rechi a casa dei clienti</0>.",
      "mobileCheckbox": "Voglio utilizzare Treatwell SOLO per il software di prenotazione e NON per il marketplace.",
      "mobileMessage": "Sfortunatamente, a causa di limitazioni, il nostro Marketplace può mostrare solo attività con un indirizzo fisso.",
      "required": "Scegli un'opzione",
      "shop": "Negozio <0>- i tuoi clienti si recano in un negozio</0>"
    },
    "city": {
      "invalid": "La città è troppo lunga",
      "label": "Città",
      "required": "Campo obbligatorio"
    },
    "country": {
      "label": "Paese",
      "required": "Campo obbligatorio"
    },
    "email": {
      "invalid": "Non valido",
      "label": "Email",
      "required": "Campo obbligatorio"
    },
    "firstName": {
      "invalid": "Si prega di non utilizzare caratteri speciali",
      "label": "Nome",
      "required": "Campo obbligatorio"
    },
    "lastName": {
      "invalid": "Si prega di non utilizzare caratteri speciali",
      "label": "Cognome",
      "required": "Campo obbligatorio"
    },
    "marketing": {
      "label": "Vorrei ricevere comunicazioni via email per far crescere la mia attività con consigli mirati."
    },
    "password": {
      "hint": "Minimo 8 caratteri",
      "invalid": "La password deve contenere almeno 8 caratteri",
      "label": "Password",
      "required": "Campo obbligatorio"
    },
    "phoneNumber": {
      "invalid": "Numero di telefono non valido",
      "label": "Numero di telefono",
      "required": "Campo obbligatorio"
    },
    "postalCode": {
      "invalid": "Il codice postale è troppo lungo",
      "label": "Codice postale",
      "required": "Campo obbligatorio"
    },
    "privacy": {
      "label": "Attivando l'account Freemium, accetti la nostra <0>informativa sulla privacy</0> e i termini e le condizioni delineati sul nostro <1>sito web</1>."
    },
    "searchBusiness": {
      "label": "Trova attività"
    },
    "street": {
      "invalid": "L'indirizzo è troppo lungo",
      "label": "Indirizzo",
      "required": "Campo obbligatorio"
    }
  },
  "salesMode": {
    "enterPassword": "Inserisci la password per la modalità vendita",
    "invalidPassword": "password non valida"
  },
  "stepContext": {
    "attractNewClients": "Attira nuovi clienti",
    "buildRelationships": "Crea relazioni ancora migliori con i tuoi clienti",
    "growBusiness": "Fai crescere la tua attività in modo splendido",
    "manageAppointments": "Gestisci tutti i tuoi appuntamenti in movimento",
    "prompt": "Sei a pochi passi (e circa 3 minuti) dall'unirti ad una comunità di oltre 75.000 saloni che gestiscono la loro attività, moltiplicano i loro clienti e aumentano il proprio fatturato.<br /><br />Con Treatwell potrai:",
    "prompt2": "...e molto altro ancora",
    "title": "<0>Entrare a far parte di Treatwell</0> - la più grande piattaforma di saloni di bellezza e parrucchieri in Europa - non è mai stato così semplice."
  },
  "stepCounter": {
    "step0": "Step 1",
    "step1": "Step 1",
    "step2": "Step 2",
    "step3": "Step 3",
    "step4": "Step 4",
    "step5": "Congratulazioni"
  },
  "stepEmailVerification": {
    "resend": "Rinvia",
    "subTitle1": "Basta inserire il codice per completare la registrazione.",
    "subTitle2": "Non l'hai ricevuto?",
    "title": "<0>Ci siamo quasi,</0> ti abbiamo inviato un'email con un codice di 6 cifre!"
  },
  "stepError": {
    "accountCreation": "Creazione del tuo account",
    "body": "Stiamo riscontrando dei problemi.\nPer favore, attendi un minuto e riprova.",
    "bodyWithError": "Stiamo riscontrando problemi con {{reason}}.\nPer favore, attendi un minuto e riprova.",
    "button": "Riprova",
    "title": "Oops, qualcosa è andato storto!"
  },
  "stepFinal": {
    "joke1Punchline": "Il barboncino!",
    "joke1Setup": "Qual è il cane preferito dai barbieri?",
    "joke2Punchline": "Ha tagliato il traguardo!",
    "joke2Setup": "Come ha fatto il parrucchiere a vincere la gara?",
    "joke3Punchline": "La coda!",
    "joke3Setup": "Cosa fanno tante donne dal parrucchiere che aspettano un taglio di capelli?",
    "joke4Punchline": "",
    "joke4Setup": "",
    "joke5Punchline": "",
    "joke5Setup": "",
    "subTitle": "In attesa, queste battute sono capelli-scenti!",
    "title": "Grazie, configuriamo il tuo profilo! <br />Dacci <0>due minuti...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "Registrati",
    "alternativeMessage": "Stai usando la stessa sede per registrare una nuova attività?",
    "button": "Accedi a Treatwell",
    "message": "<0>Buone notizie!</0> La tua attività è già su Treatwell."
  },
  "stepFourForm": {
    "prompt1": "Useremo queste informazioni per creare il tuo account e per contattarti in caso di necessità.",
    "title": "Parlaci di te"
  },
  "stepOneForm": {
    "prompt1": "Cerca o inserisci il nome della tua attività",
    "title": "Parlaci della tua attività"
  },
  "stepOneSearch": {
    "addManually": "Non riesci a trovare il tuo indirizzo? <0>Aggiungilo manualmente</0>",
    "prompt1": "Cerca o inserisci il nome della tua attività",
    "title": "Parlaci della tua attività"
  },
  "stepThreeForm": {
    "title": "Che tipo di attività hai?"
  },
  "stepTwoForm": {
    "prompt1": "Seleziona tutte le opzioni pertinenti, prima il tuo servizio principale",
    "title": "Che servizi offri?"
  }
}